import api from './api'
import { toast } from 'react-toastify'
import { toUpperCase } from '../utils/objects'

export function findAll(farmaciaId, page, itemsPerPage) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      const response = await api.get(`farmacias/${farmaciaId}/formulas`, {
        headers: { authorization: `Bearer ${token}` },
        params: { page, itemsPerPage }
      });

      return resolve(response.data);
    } catch (e) {
      toast.error("Falha ao buscar fórmulas");
      return reject(e);
    }
  })
}

export function findById(farmaciaId, formulaId) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      const response = await api.get(`farmacias/${farmaciaId}/formulas/${formulaId}`, {
        headers: { authorization: `Bearer ${token}` }
      });

      return resolve(response.data.data);
    } catch (e) {
      toast.error("Falha ao buscar fórmula");
      return reject(e);
    }
  })
}

export function save(farmaciaId, formula) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      const response = await api.post(`farmacias/${farmaciaId}/formulas`, toUpperCase(formula), {
        headers: { authorization: `Bearer ${token}` }
      });

      return resolve(response.data.data);
    } catch (e) {
      toast.error("Falha ao salvar fórmula");
      return reject(e);
    }
  })
}

export function update(farmaciaId, formulaId, formula, usuarioId) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      await api.put(`farmacias/${farmaciaId}/formulas/${formulaId}`, toUpperCase(formula), {
        headers: { authorization: `Bearer ${token}` },
        params: { usuarioId }
      });

      return resolve();
    } catch (e) {
      toast.error("Falha ao salvar fórmula");
      return reject(e);
    }
  })
}

export function remove(farmaciaId, formulaId) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      await api.delete(`farmacias/${farmaciaId}/formulas/${formulaId}`, {
        headers: { authorization: `Bearer ${token}` }
      });

      return resolve();
    } catch (e) {
      toast.error("Falha ao remover fórmula");
      return reject(e);
    }
  })
}
